import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

class Element extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        title: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object])
    };
    static defaultProps = {
        value: ''
    };

    render() {
        const { title, value, classes } = this.props;
        return (
            <div className="d-flex py-1">
                <div className={`d-flex pr-2 ${classes.title}`}>{title} : </div>
                <div>{value} </div>
            </div>
        );
    }
}

const styles = () => ({
    title: {
        color: '#858585'
    }
});
export default withStyles(styles, { withTheme: true })(Element);



// WEBPACK FOOTER //
// ./environments/testbench/scenes/Boxes/components/Element.js